import { ChatContent, ChatTopic } from "@/types/writing";
import { createAsyncThunk } from "@reduxjs/toolkit";

function getCSRFFromCookie() {
  if (typeof document !== 'undefined' && typeof document.cookie !== 'undefined') {
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
          const cookie = cookies[i].trim();
          if (cookie.startsWith('MMCSRF=')) {
              return cookie.replace('MMCSRF=', '');
          }
      }
  }
  return '';
}

export const getChats = createAsyncThunk("users/chats", async (userId: string, { rejectWithValue }) => {
  const response = await fetch(`/api/v4/chats?user_id=${userId}`, { method: "GET" });
  if (!response.ok) {
    rejectWithValue(`Server responded with status code ${response.status}`);
  }
  const result: ChatTopic[] = await response.json();
  return result;
});

export const getChatMsgs = createAsyncThunk("users/chatMsgs", async (chatId: string, { rejectWithValue }) => {
  const response = await fetch(`/api/v4/chats/msg?chat_id=${chatId}`, { method: "GET" });
  if (!response.ok) {
    rejectWithValue(`Server responded with status code ${response.status}`);
  }
  const result: ChatContent[] = await response.json();
  return result;
});

export const deleteChat = createAsyncThunk("users/deletechat", async (chat: ChatTopic, { rejectWithValue }) => {
  const response = await fetch(`/api/v4/chats?chat_id=${chat.id}`, { method: "DELETE",headers:{"Content-Type": "application/json","X-CSRF-Token":getCSRFFromCookie()} });
  if (!response.ok) {
    rejectWithValue(`Server responded with status code ${response.status}`);
  }
  const data: string = await response.json();
  return data;
});

export const updateChat = createAsyncThunk("users/updatechat", async (chat: ChatTopic, { rejectWithValue }) => {
  const response = await fetch("/api/v4/chats", {
    method: "PUT",
    body: JSON.stringify(chat),
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token":getCSRFFromCookie()
    },
  });
  if (!response.ok) {
    rejectWithValue(`Server responded with status code ${response.status}`);
  }
  const data: ChatTopic = await response.json();
  return data;
});

export const addChat = createAsyncThunk("users/addchat", async (chat: Omit<ChatTopic, "id">, { rejectWithValue }) => {
  const response = await fetch("/api/v4/chats", {
    method: "POST",
    body: JSON.stringify(chat),
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token":getCSRFFromCookie()
    },
  });
  if (!response.ok) {
    rejectWithValue(`Server responded with status code ${response.status}`);
  }
  const data: ChatTopic = await response.json();
  return data;
});

export const sendMsg = createAsyncThunk("users/sendmsg", async (chat: Omit<ChatContent, "parent_id" | "message_role"|"once">, { rejectWithValue }) => {
  const response = await fetch(`/api/v4/chats/sendmsg`, {
    method: "POST",
    body: JSON.stringify(chat),
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token":getCSRFFromCookie()
    },
  });
  if (!response.ok) {
    rejectWithValue(`Server responded with status code ${response.status}`);
  }
  const data = await response.json();
  return data;
});

export const sendMsg2 = createAsyncThunk("users/resetmsg", async (chat: ChatContent, { rejectWithValue }) => {
  const response = await fetch(`/api/v4/chats/resetmsg`, {
    method: "POST",
    body: JSON.stringify(chat),
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token":getCSRFFromCookie()
    },
  });
  if (!response.ok) {
    rejectWithValue(`Server responded with status code ${response.status}`);
  }
  const data = await response.json();
  return data;
});

export const connect = createAsyncThunk("users/connect", async (user_id: string, { rejectWithValue }) => {
  const response = await fetch(`/api/v4/chats/connect?user_id=${user_id}`, { method: "GET" });
  if (!response.ok) {
    rejectWithValue(`Server responded with status code ${response.status}`);
  }
  const data = await response.json();
  return data;
});
